var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EE6666",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 31.619,
    height: 31.619,
    rx: 15.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_47_7",
    maskUnits: "userSpaceOnUse",
    x: 11.9524,
    y: 6.47607,
    width: 13,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 11.9524,
    y: 6.47607,
    width: 13,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2682 24.4761V6.96253H16.9818V21.4094H24.0854V24.4761H13.2682Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2682 24.4761V6.96253H16.9818V21.4094H24.0854V24.4761H13.2682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2682 24.4761H12.8873V24.857H13.2682V24.4761ZM13.2682 6.96253V6.58158H12.8873V6.96253H13.2682ZM16.9818 6.96253H17.3627V6.58158H16.9818V6.96253ZM16.9818 21.4094H16.6008V21.7904H16.9818V21.4094ZM24.0854 21.4094H24.4664V21.0285H24.0854V21.4094ZM24.0854 24.4761V24.857H24.4664V24.4761H24.0854ZM13.6492 24.4761V6.96253H12.8873V24.4761H13.6492ZM13.2682 7.34348H16.9818V6.58158H13.2682V7.34348ZM16.6008 6.96253V21.4094H17.3627V6.96253H16.6008ZM16.9818 21.7904H24.0854V21.0285H16.9818V21.7904ZM23.7045 21.4094V24.4761H24.4664V21.4094H23.7045ZM24.0854 24.0951H13.2682V24.857H24.0854V24.0951Z",
    fill: "black",
    mask: "url(#path-3-outside-1_47_7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_7",
    x: 0.47619,
    y: 0,
    width: 35.0476,
    height: 35.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_7",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL);
export default __webpack_public_path__ + "static/media/L.a24cb4a5e4eaba7759747c02858db2ba.svg";
export { ForwardRef as ReactComponent };